// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__O-9Hv","footer":"Form_footer__H84VY"};